import { IPresignedUrlBodyListItem, IPresignedUrlResponseListItem } from '@types';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function postAdminPresignedUrl(
  body: IPresignedUrlBodyListItem[]
): Promise<AxiosResponse<FetchResult<IPresignedUrlResponseListItem[]>>> {
  const response = await instance.post(`/images/presigned-url`, { images: body });
  return response;
}

const usePostAdminPresignedUrl = (
  onSuccess?: (data: AxiosResponse<FetchResult<IPresignedUrlResponseListItem[]>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { data, mutate, mutateAsync } = useMutation({
    mutationKey: ['post', `/images/presigned-url`],
    mutationFn: (body: IPresignedUrlBodyListItem[]) => postAdminPresignedUrl(body),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { data, mutate, mutateAsync };
};

export default usePostAdminPresignedUrl;
